<template>
  <div>
    <v-dialog
      v-model="dialog"
      :max-width="maxWidth"
      persistent
      :content-class="windowClass"
      :scrollable="scrollable"
    >
      <slot
        name="content"
        :cancel="cancel"
        :data="data"
        :isShow="dialog"
        :title="title"
      ></slot>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EligibilityBaseDialog",
  props: {
    windowClass: String,
    maxWidth: {
      type: Number,
      default: 800,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      data: null,
      dialog: false,
      title: "",
    };
  },
  methods: {
    open(title, data) {
      this.dialog = true;
      this.title = title;
      this.data = data;
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-card) {
  .v-card__text {
    color: initial;
    font-size: initial;
    font-weight: initial;
    line-height: inherit;
    letter-spacing: inherit;
    scrollbar-gutter: stable;

    &::-webkit-scrollbar {
      width: 20px;
    }

    &::-webkit-scrollbar-track,
    &::-webkit-scrollbar-thumb {
      border-radius: 1000px;
      border: solid 6px transparent;
    }

    &::-webkit-scrollbar-track {
      margin: 18px 0px;
      box-shadow: inset 0 0 5px 5px #ebebeb;
    }
    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 5px 5px #aaaaaa;
    }
  }
}
</style>
